import { render, staticRenderFns } from "./PricingAndAvailablity.vue?vue&type=template&id=21190287&"
import script from "./PricingAndAvailablity.vue?vue&type=script&lang=js&"
export * from "./PricingAndAvailablity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports